import React from 'react';
import { Chip, Link } from '@mui/material';
import PropTypes from 'prop-types';

function chipColorFor(kind) {
  if (kind === 'responded') return 'responded';
  if (kind === 'ltfu') return 'ltfu';
  if (kind === 'error') return 'error';
  return 'fu';
}

export function FuTag({ label, kind = 'fu', frontUrl = null, title = null }) {
  if (!label) return null;
  const chip = (
    <Chip
      size="small"
      color={chipColorFor(kind)}
      label={label}
      data-testid="onyx-fu-tag"
    />
  );
  const tagged = title ? <span title={title}>{chip}</span> : chip;
  if (!frontUrl) return tagged;
  return (
    <Link href={frontUrl} target="_blank" rel="noopener noreferrer" underline="none">
      {tagged}
    </Link>
  );
}

FuTag.propTypes = {
  label: PropTypes.string,
  kind: PropTypes.oneOf(['fu', 'responded', 'ltfu', 'idv', 'error']),
  frontUrl: PropTypes.string,
  title: PropTypes.string,
};
